import React from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Login from './components/Login/LoginForm'
import Role from './components/Role/Role'
import Taskview from './components/TaskView/Taskview'
import DashboardComponent from './components/TaskView/WorkPlace/DashboardComponent'
import iframe from './components/TaskView/iframe'
import InspectionPopUp from './components/WindowPopUp/InspectionPopUp'
import GenerateQRCode from './components/WindowPopUp/GenerateQRCode'
import SelectQRCodeProfile from './components/WindowPopUp/SelectQRCodeProfile'
//import OilRecordBook from './components/Modules/OnBoardBooks/OilRecordBook'

class App extends React.Component {
    
    render() {
     
        return (
                <Router>
                    <div>
                        <Route path='/' exact strict component={Login} />
                        <Route path='/Role' exact strict component={Role} />
                        <Route path='/TaskView' exact component={Taskview} />
                        <Route path='/Dashboard'  component={DashboardComponent} />
                        <Route path='/iframe' strict component={iframe} />
                        <Route path='/inspectionPopUp' strict component={InspectionPopUp} />
                        <Route path='/SelectQRCodeProfile' strict component={SelectQRCodeProfile} />
                        <Route path='/GenerateQRCode' strict component={GenerateQRCode} />
                 
                    </div>
                </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js